<template>
  <div class="opera-ftxq">
    <topNav :title="$t('fangTXQ_title')" url="/opera/fangT" replace="true"></topNav>
    <div class="warp" v-if="orderInfo.fMasterDto">
      <div class="orderSta clearfix">
        <div class="Num">{{$t('fangTXQ_rsvNo')}}:
          <span>{{orderInfo.fMasterDto.masterBase.rsvNo}}</span>
          {{orderInfo.fMasterDto.masterBase.rsvClass | orderDis}}
        </div>
        <div class="sta">{{$t('fangTXQ_sta')}}:
          <span>{{orderInfo.fMasterDto.masterBase.sta}}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('fangTXQ_baseInfo')}}
          </div>
          <ul class="infoContent twocol">
            <li>{{$t('fangTXQ_name')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterGuest.name}}</span>
            </li>
            <li>{{$t('fangTXQ_mobile')}}:
              <span class="infoVal"> <a :href='"tel:"+orderInfo.fMasterDto.masterGuest.mobile'>{{orderInfo.fMasterDto.masterGuest.mobile}}</a></span>
            </li>
            <li v-if="orderInfo.fMasterDto.masterGuest.name2">{{$t('fangTXQ_name2')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterGuest.name2}}</span>
            </li>
            <li v-if="orderInfo.fMasterDto.masterGuest.firstName">{{$t('fangTXQ_firstName')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterGuest.firstName}} / {{orderInfo.fMasterDto.masterGuest.lastName}}</span>
            </li>
            <li>{{$t('fangTXQ_rmno')}}:
              <span class="infoVal" style="color:red">{{orderInfo.fMasterDto.masterBase.rmno}}</span>
            </li>
            <li>{{$t('fangTXQ_rmtype')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.rmtype}}</span>
            </li>
            <li>{{$t('fangTXQ_arr')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.arr | dateD}}</span>
            </li>
            <li>{{$t('fangTXQ_dep')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.dep | dateD}}</span>
            </li>
            <li>{{$t('fangTXQ_memberNo')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.memberNo}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_idCode')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterGuest.idCode}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_idNo')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterGuest.idNo}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_companyName')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.companyName}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_agentName')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.agentName}}</span>
            </li>
            <li class="p100">{{$t('fangTXQ_sourceName')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.sourceName}}</span>
            </li>
            <li style="clear:both">{{$t('fangTXQ_ratecode')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.ratecode}}</span>
            </li>
            <li>{{$t('fangTXQ_rate')}}:
              <span class="infoVal" style="color:red">￥{{orderInfo.fMasterDto.masterBase.realRate}}</span>
              <i class="mintui mintui-more" @click="getEveryDateRate"></i>
            </li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('fangTXQ_market_sales')}}
          </div>
          <ul class="infoContent twocol">
            <li>{{$t('fangTXQ_salesman')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.salesman}}</span>
            </li>
            <li>{{$t('fangTXQ_cmscode')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.cmscode}}</span>
            </li>
            <li>{{$t('book_market')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.market}}</span>
            </li>
            <li>{{$t('fangTXQ_src')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.src}}</span>
            </li>
            <li>{{$t('fangTXQ_channel')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.channel}}</span>
            </li>
            <li>{{$t('fangTXQ_crsNo')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.crsNo}}</span>
            </li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('fangTXQ_other')}}
          </div>
          <ul class="infoContent">
            <li style="height: auto;">{{$t('fangTXQ_remark')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.remark}}</span>
            </li>
            <li>{{$t('fangTXQ_createUser')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.createUser}}</span>
            </li>
            <li>{{$t('fangTXQ_createDatetime')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.createDatetime}}</span>
            </li>
            <li>{{$t('fangTXQ_modifyUser')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.modifyUser}}</span>
            </li>
            <li>{{$t('fangTXQ_modifyDatetime')}}:
              <span class="infoVal">{{orderInfo.fMasterDto.masterBase.modifyDatetime}}</span>
            </li>
          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('fangTXQ_al_room')}}
          </div>
          <div class="infoContent" style='border-bottom: none;'>
            <ul class="lf">
              <li v-for="(val,key) in orderInfo.masterLinkListNew" @click="goLinkRoom(val.id)" :key="val.id">
                {{val.rmno}} <b>{{val.sta}}</b>
              </li>
            </ul>

          </div>


        </div>
      </div>
      <div class="bill">
        <div class="billtop">{{$t('fangTXQ_bill')}}</div>
        <div class="billContent">
          <ul class="billList clearfix">
            <li>{{$t('fangTXQ_masterBase')}}:
              <span>{{(orderInfo.fMasterDto.masterBase.charge-orderInfo.fMasterDto.masterBase.pay).toFixed(2)}}</span>
            </li>
            <li>{{$t('fangTXQ_credit')}}:
              <span>{{orderInfo.fMasterDto.masterBase.credit.toFixed(2)}}</span>
            </li>
            <li>{{$t('fangTXQ_othBalance')}}:
              <span>{{orderInfo.othBalance.toFixed(2)}}</span>
            </li>
            <li>{{$t('fangTXQ_othCredit')}}:
              <span>{{orderInfo.othCredit.toFixed(2)}}</span>
            </li>
          </ul>
          <table class="itemsList">
            <tr class="category">
              <th width="36px">
                <span>{{$t('fangT_rmno')}}</span>
              </th>
              <th width="108px">
                <span>{{$t('fangTXQ_project')}}</span>
              </th>
              <th width="64px">
                <span>{{$t('fangTXQ_time')}}</span>
              </th>
              <th width="68px">
                <span>{{$t('fangTXQ_operator')}}</span>
              </th>
              <th width="50px">
                <span>{{$t('fangTXQ_amount')}}</span>
              </th>
            </tr>
            <tr class="item" v-for="(val,key) in orderInfo.acclist">
              <td>{{val.rmno}}</td>
              <td>{{val.taDescript}}</td>
              <td>
                <p class="small">{{val.genDate | dateD}}</p>
              </td>
              <td>{{val.createUser}}</td>
              <td>{{ val.arrangeCode.indexOf('9') == 0 ? val.pay : val.charge}}</td>
            </tr>
          </table>
        </div>

      </div>
      <div class="dx">
      {{$t('loading_end_message')}}
      </div>
      <div class="btnBottom ">
        <div class="staI " v-if="orderInfo.fMasterDto.masterBase.sta=='R'"
             v-show="orderInfo.rights.indexOf('recept!fit!ci') >= 0">
          <div class="btn" @click='cancelOrder'>{{$t('fangTXQ_cancelOrder')}}</div>
          <div class="btn" @click='checkIn'>{{$t('fangTXQ_checkIn')}}</div>
        </div>
        <div class="staR l_o_btm" v-if="orderInfo.fMasterDto.masterBase.sta=='I'">
          <div class="btn" @click='addReceive(1)' v-if="orderInfo.rights.indexOf('act!posting') >= 0">{{$t('fangTXQ_addReceive1')}}</div>
          <div class="btn" @click='addReceive(0)' v-if="orderInfo.rights.indexOf('act!posting') >= 0">{{$t('fangTXQ_addReceive0')}}</div>
          <div class="btn" @click='keepDebts' v-if="orderInfo.rights.indexOf('act!suspend') >= 0">{{$t('fangTXQ_keepDebts')}}</div>
          <div class="btn" @click='checkOut(true)' v-if="orderInfo.rights.indexOf('act!checkout') >= 0">{{$t('fangTXQ_checkOut')}}</div>
        </div>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom" class="checkOutPop" :modal="true">
      <div class="checkoutinfoPop">
        <div class="checkList">
          <label>{{$t('fangTXQ_needMoney')}} :</label> <input type="text" v-model="checkOutInfo.needMoney" readonly="readonly"></div>
        <div class="checkList">
          <label>{{$t('fangTXQ_needMoney2')}} :</label> <input type="text" v-model="checkOutInfo.needMoney" readonly="readonly"></div>
        <div class="checkList">
          <label>{{$t('fangTXQ_checkMethod')}} :</label>
          <select v-model="checkMethod">
            <option v-for="(item,index,key) in checkOutInfo.accCodes" :value="item.code" :key="item.code">{{item.name}}
            </option>
          </select>
        </div>
        <div class="checkList">
          <label>{{$t('fangTXQ_payName')}} :</label> <input type="text" v-model="checkOutInfo.name" readonly="readonly"></div>
        <div class="checkList">
          <label>{{$t('fangTXQ_invoice_title')}} :</label> <input type="text"></div>
      </div>
      <div class="popBottom">
        <div class="cCancle" @click='popupVisible=false'>{{$t('cancel')}}</div>
        <div class="cSure" @click='surePay'>{{$t('determine')}}</div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupEvalDay" position="bottom" class="everyDatePop" :modal="true">
      <table class="checkList" align='center' style="border-collapse:collapse;">
        <tbody>
        <tr>
          <th width="40%">{{$t('fangTXQ_date')}}</th>
          <th width="30%">{{$t('fangTXQ_rate')}}</th>
          <th width="30%">{{$t('fangTXQ_rmnum')}}</th>
        </tr>
        </tbody>
        <tr>
          <td>{{$t('fangTXQ_total')}}</td>
          <td>{{sumRate(dateRate)}}</td>
          <td></td>
        </tr>
        <tr v-for="item in dateRate" :key="item.rsv_date">
          <td>{{item.rsv_date | dateF}}</td>
          <td>
            <small>￥</small>
            {{item.realShareRate}}
          </td>
          <td>{{item.rmnum}}</td>
        </tr>
      </table>
    </mt-popup>
    <actionsheet :actions="actions" v-model="sheetVisible"></actionsheet>
  </div>
</template>

<script>
  import {Toast, MessageBox, Actionsheet} from "mint-ui";

  export default {
    data() {
      return {
        orderInfo: {},
        popupVisible: false,
        checkOutInfo: {},
        checkMethod: "",
        dateRate: [],
        popupEvalDay: false,
        sheetVisible: false,
        actions: []
      };
    },
    mounted() {
      this.getrmInfo();
    },
    methods: {
      /*房间信息获取*/
      getrmInfo() {
        this.$http
          .post("/mobilepmsapi/reception/getRoomStatusDetail", this.$route.query)
          .then(res => {
            this.getrmInfoAfter(res);
          });
      },
      getrmInfoById(id) {
        this.$http
          .post("/mobilepmsapi/reception/getRoomStatusDetail", {id: id})
          .then(res => {
            this.getrmInfoAfter(res);
          });
      },
      getEveryDateRate() {
        this.popupEvalDay = true;
        var mb = this.orderInfo.fMasterDto.masterBase;
        this.$http
          .post("/mobilepmsapi/reception/getEveryDateRate", {
            masterId: mb.id,
            arr: mb.arr,
            dep: mb.dep
          })
          .then(res => {
            this.dateRate = res.data.retVal;
          });
      },
      getrmInfoAfter(res) {
        if (res.data.result == 0) {
          this.orderInfo = res.data.retVal;
          // console.log(this.orderInfo);
        } else if (res.data.result == 56020) {
          //错误代码返回预订页
          var q = this.$route.query;
          q.isReserve = false;
          this.$router.push({path: "/opera/book", query: q});
        } else {
          this.msg(res.data.msg);
        }
      },
      goLinkRoom(id) {
        var url = "/opera/fangTXQ?id=" + id;
        if (this.$route.query.redirect != null) {
          url += "&redirect=" + encodeURIComponent(this.$route.query.redirect);
        }
        this.$router.push(url);
        this.getrmInfo();
      },
      /*加收房费*/
      addReceive(value) {
        MessageBox.confirm(value == 0 ? this.$t('fangTXQ_addReceiveMsg0') : this.$t('fangTXQ_addReceiveMsg1'), "")
          .then(action => {
            this.addReceiveP(value, false);
          })
          .catch(action => {
            console.log("不进行挂账");
          });
      },
      addReceiveP(value, recheck) {
        this.$http
          .post("/mobilepmsapi/reception/roomAddCharge", {
            id: this.orderInfo.fMasterDto.masterBase.id,
            type: value
          })
          .then(res => {
            if (res.data.result == 0) {
              this.getrmInfo();
              this.msg(this.$t('msg_addReceive_success'));
              if (recheck) {
                this.checkOut(false);
              }
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      /*挂账*/
      keepDebts() {
        console.log(this.orderInfo);
        MessageBox.confirm(this.$t('MessageBox_keepDebts'), "")
          .then(action => {
            if (action == "confirm") {
              this.$http
                .post("/mobilepmsapi/reception/roomSuspend", {
                  id: this.orderInfo.fMasterDto.masterBase.id,
                  suspendTag: 2
                })
                .then(res => {
                  if (res.data.result == 0) {
                    this.msg(this.$t('msg_keepDebts_success'));
                    this.getrmInfoById(this.orderInfo.fMasterDto.masterBase.id);
                  } else {
                    this.msg(res.data.msg);
                  }
                });
            }
          })
          .catch(action => {
            console.log("不进行挂账");
          });
      },
      checkOutAdd() {
        MessageBox.confirm(this.$t('MessageBox_checkOutAdd'))
          .then(action => {
            this.actions = [];
            this.actions.push({
              name: this.$t('MessageBox_checkOutAdd_action0'),
              method: () => {
                this.addReceiveP(0, true);
              }
            });
            this.actions.push({
              name: this.$t('MessageBox_checkOutAdd_action1'),
              method: () => {
                this.addReceiveP(1, true);
              }
            });
            this.sheetVisible = true;
          })
          .catch(action => {
          });
      },
      /*退房--获取退房前信息*/
      checkOut(tip) {
        this.$http
          .post(
            "/mobilepmsapi/reception/getCheckoutInfo/" +
            this.orderInfo.fMasterDto.masterBase.id
          )
          .then(res => {
            if (res.data.result == 0) {
              if (
                this.checkOut.accCodes != null &&
                this.checkOut.accCodes.length > 0
              ) {
                this.checkMethod = this.checkOut.accCodes[0];
              }
              this.popupVisible = true;
              this.checkOutInfo = res.data.retVal;
              this.checkMethod = this.checkOutInfo.accCodes[0].code;
              if (
                tip &&
                (this.checkOutInfo.addChangeType >= 0 ||
                  this.orderInfo.acclist == null ||
                  this.orderInfo.acclist.length == 0)
              ) {
                this.checkOutAdd();
              }
            }
          });
      },
      /*办理入住*/
      checkIn() {
        MessageBox.confirm(this.$t('MessageBox_checkIn'))
          .then(action => {
            this.$http
              .get(
                "/mobilepmsapi/reception/roomCheckIn/" +
                this.orderInfo.fMasterDto.masterBase.id
              )
              .then(res => {
                if (res.data.result == 0) {
                  this.checkOutInfo = res.data.retVal;
                  this.getrmInfo();
                  this.msg(this.$t('msg_checkin_success'));
                } else {
                  this.msg(res.data.msg);
                }
              });
          })
          .catch(action => {
          });
      },
      cancelOrder() {
        MessageBox.prompt(this.$t('MessageBox_cancelOrder'))
          .then(({value, action}) => {
            this.$http
              .post("/mobilepmsapi/reception/cancelOrder", {
                id: this.orderInfo.fMasterDto.masterBase.id,
                reason: value
              })
              .then(res => {
                if (res.data.result == 0) {
                  this.msg(this.$t('msg_cancel_success'));
                  if (this.$route.query.redirect != null) {
                    this.$router.push(this.$route.query.redirect);
                  } else {
                    this.$router.push("/opera/fangT");
                  }
                } else {
                  this.msg(res.data.msg);
                }
              });
          })
          .catch(action => {
          });
      },
      /*退房确认*/
      surePay() {
        if (!this.checkMethod) {
          this.msg(this.$t('msg_choose_checkMethod'));
        } else {
          this.popupVisible = false;
          this.$http
            .post("/mobilepmsapi/reception/checkout", {
              id: this.orderInfo.fMasterDto.masterBase.id,
              ta: this.checkMethod,
              pay: this.checkOutInfo.needMoney
            })
            .then(res => {
              if (res.data.result == 0) {
                console.log("pay success");
                this.popupVisible = false;
                this.getrmInfoById(this.orderInfo.fMasterDto.masterBase.id);
              } else {
                this.popupVisible = true;
                this.msg(res.data.msg);
              }
            });
        }
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
      },
      sumRate(value) {
        var sum = 0;
        for (var i = 0; i < this.dateRate.length; i++) {
          sum += this.dateRate[i].realShareRate * this.dateRate[i].rmnum;
        }
        return sum;
      }
    },
    filters: {
      dateF(value) {
        return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
      },
      dateD(value) {
        return value != "" ? value.replace(/-/g, "/").substring(5, 16) : "";
      },
      orderDis(value) {
        switch (value) {
          case "D":
            return "（"+this.$t('fangTXQ_orderDisD')+"）";
          case "G":
            return "（"+this.$t('fangTXQ_orderDisG')+"）";
          default:
            return "";
        }
      }
    },
    components: {
      actionsheet: Actionsheet
    }
  };
</script>
<style lang='less'>
  .opera-ftxq {
    background-color: #f7f8fa;

    .warp {
      margin: 10px;
      // background-color: #fff;
      .orderSta {
        background-color: #f6f8f9;
        height: 29px;
        line-height: 26px;
        color: #333;
        padding-bottom: 15px;
        padding: 0 0 3px 0;

        .Num {
          float: left;
          margin-left: 8px;
        }

        .sta {
          float: right;
          margin-right: 8px;

          span {
            color: #ffffff;
            font-weight: bold;
            font-size: 16px;
            border-radius: 12px;
            display: inline-block;
            width: 22px;
            height: 22px;
            text-align: center;
            background: #646f83;
            vertical-align: middle;
            line-height: 22px;
          }
        }
      }

      .infoList {
        padding: 15px 0 15px 0;
        background-color: #fff;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        overflow: hidden;

        .info {
          padding: 0px 0px 15px;

          .infoTop {
            padding: 0 18px;
            position: relative;
            height: 20px;
            line-height: 20px;

            .icon-changfangxingbiaoqian {
              position: absolute;
              font-size: 12px;
              left: 0;
              top: 1px;
              color: #f6a624;
            }

            .addGuest {
              float: right;
              background-color: #f6a624;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              text-align: center;

              .iconfont {
                color: #fff;
                font-size: 12px;
                line-height: 20px;
              }
            }
          }

          .lf {
            clear: both;

            margin-left: 10px;

            li {
              float: left;
              line-height: 20px;
              margin-right: 20px;

              .infoVal {
                margin-left: 8px;
              }
            }
          }

          .infoContent {
            margin: 0 20px;
            padding: 10px 0;
            border-bottom: 1px dashed #ddd;

            li {
              line-height: 20px;

              .infoVal {
                margin-left: 8px;

                a {
                }
              }
            }

            .p100 {
              clear: both;
              width: 100% !important;
            }

            .mintui-more {
              color: #999;
              margin-left: 10px;
            }

            &.twocol {
              overflow: hidden;

              li {
                width: 50%;
                float: left;
              }
            }
          }

          .checkIn {
            margin: 0 20px;

            li {
              height: 36px;

              .list {
                float: left;
                width: 33.3%;
                text-align: left;
                line-height: 36px;

                .btn {
                  height: 24px;
                  margin-top: 6px;
                  width: 53px;
                  background-color: #f6a624;
                  float: right;
                  text-align: center;
                  line-height: 24px;
                  border-radius: 2px;
                  color: #fff;
                }
              }
            }
          }
        }
      }

      .bill {
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin-top: 10px;
        background-color: #fff;
        clear: both;

        .billtop {
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          line-height: 40px;
          height: 40px;
          box-sizing: border-box;
          border-bottom: 1px dashed #ddd;
        }

        .billContent {
          padding: 0 10px 10px;

          .billList {
            padding: 18px 3px;

            li {
              float: left;
              width: 50%;
              box-sizing: border-box;
              height: 25px;
              line-height: 25px;
              font-size: 12px;

              span {
                margin-left: 5px;
              }
            }
          }

          .itemsList {
            width: 100%;

            .category {
              background-color: #a4a4a4;
              height: 39px;
              color: #fff;

              th {
                span {
                  width: 100%;
                  display: block;
                  border-right: 1px solid rgba(255, 255, 255, 0.3);
                }
              }
            }

            .item {
              height: 41px;

              td {
                text-align: center;
              }

              .small {
                transform-origin: center;
                transform: scale(0.83);
              }

              &:nth-of-type(2n) {
                background-color: #f5f5f5;
              }
            }
          }
        }
      }

      .btnBottom {
        position: absolute;
        left: 0;
        z-index: 100;
        bottom: 0;
        width: 100%;
        padding-top: 45px;

        .staI {
          text-align: center;
          color: #fff;
          font-size: 16px;
          line-height: 45px;
          height: 45px;
          background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

          .btn {
            float: left;
            width: 50%;
            text-align: center;
            color: #fff;
            height: 15px;
            font-size: 15px;
            line-height: 15px;
            margin-top: 15px;
            box-sizing: border-box;
            border-right: 1px solid rgba(255, 255, 255, 0.5);
          }
        }

        .staR {
          height: 45px;
          background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

          .btn {
            float: left;
            width: 25%;
            text-align: center;
            color: #fff;
            height: 15px;
            font-size: 15px;
            line-height: 15px;
            margin-top: 15px;
            box-sizing: border-box;
            border-right: 1px solid rgba(255, 255, 255, 0.5);
          }
        }
      }
    }

    .everyDatePop {
      width: 100%;
      height: 50%;
      overflow-y: scroll;

      .checkList {
        width: 100%;

        tr {
          background-color: #fff;

          &:nth-of-type(2n) {
            background-color: #f5f5f5;
          }

          font-size: 0.32rem;

          th {
            color: #fff;
            height: 1.06666667rem;
            text-align: center;
            font-size: 0.34666667rem;
            background-color: #f69c2c;
            padding: 0;
          }

          td {
            height: 1.06666667rem;
            padding: 0px;
            text-align: center;
          }
        }
      }
    }

    .checkOutPop {
      width: 100%;
      height: 10rem;
      background: #fff; // padding-bottom:35px;
      overflow-y: auto;
      overflow-x: hidden;
      position: fixed;
      bottom: 0;

      .checkList {
        width: 100%;
        height: 40px;
        padding: 5px 10px;
        text-align: left;
        line-height: 40px;
        font-size: 14px;
        position: relative;

        label {
          height: 40px;
          line-height: 40px;
          width: 80px;
          float: left;
        }

        input {
          box-sizing: border-box;
          padding: 2px 5px;
          float: left;
          height: 30px;
          margin-top: 5px;
          line-height: 25px;
          width: 6rem;
          border-radius: 4px;
        }

        select {
          border: solid 1px #000;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
          padding-right: 14px;
          box-sizing: border-box;
          padding: 2px 5px;
          float: left;
          height: 30px;
          margin-top: 5px;
          line-height: 25px;
          width: 6rem;
          border-radius: 4px;
          background-image: linear-gradient(0deg, #e1e1e1 0%, #f9f9f9 98%);
        }

        select::-ms-expand {
          display: none;
        }

        .iconfont {
          background-color: #686868;
          width: 30px;
          line-height: 30px;
          position: absolute;
          top: 11px;
          text-align: center;
          left: 310px;
          border-radius: 0 5px 5px 0;
          height: 28px;
        }
      }

      .popBottom {
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

        .cCancle,
        .cSure {
          float: left;
          height: 100%;
          width: 50%;
          color: #fff;
          font-size: 16px;
          box-sizing: border-box;
          border-right: 2px solid #fff;
          text-align: center;
          line-height: 45px;
        }

        .cSrue {
          border-right: none;
        }
      }
    }

    .dx {
      padding-bottom: 60px;
      text-align: center;
      height: 20px;
      margin-top: 20px;
      line-height: 20px;
      color: #eee;

      span {
        color: #ddd;
      }
    }

    .mint-toast.is-placebottom {
      z-index: 3000;
    }
  }
</style>



// WEBPACK FOOTER //
// fangTXQ.vue?0d92781e